import { Profile } from '@/models/Profile';
import { setSelectedProfile } from '@/services/ProfileService';
import { ApplicationState } from '@/store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import HomeAdmin from '../Home/home';
import { HomeStudent } from '../Student/Home';

const Master: React.FC = () => {
    const [home, setHome] = useState(<></>);
    const { user, person } = useSelector((state: ApplicationState) => state.identity.data);
    const history = useHistory();

    useEffect(() => {
        if (person.dynamicAttributes) {
            const isStudent: boolean = person.dynamicAttributes.selectedProfile === 'STUDENT';
            if (isStudent) {
                setSelectedProfile('STUDENT');
                setHome(<HomeStudent />);
                return;
            }

            const isHr: boolean = person.dynamicAttributes.selectedProfile === 'HR';
            if (isHr) {
                setSelectedProfile('HR');
                setHome(<HomeAdmin />);
                return;
            }
        }

        if (user.profiles) {
            const isStudent: boolean = user.profiles.find((p: Profile) => p.profileKey === 'STUDENT') !== undefined;
            if (isStudent) {
                setSelectedProfile('STUDENT');
                setHome(<HomeStudent />);
                return;
            }

            const isHr: boolean = user.profiles.find((p: Profile) => p.profileKey === 'HR') !== undefined;
            if (isHr) {
                setSelectedProfile('HR');
                setHome(<HomeAdmin />);
                return;
            }
        }

        history.push('/logout');
    }, [history, person.dynamicAttributes, user.profiles]);

    return home;
};

export default Master;
